import type { ComputedRef, MaybeRefOrGetter } from 'vue'
import { computed, toValue } from 'vue'

import type { TableVariants } from './constants'
import { tableVariants } from './constants'

const flatClasses =
  'tw-px-4 tw-py-2 tw-border-sf-snow-dark tw-border tw-border-solid'

const dsHeaderClasses =
  'tw-h-10 tw-px-4 tw-py-3 tw-bg-sf-slate-subtle-2 tw-border-0 tw-border-b tw-border-solid tw-border-sf-slate-lighter-1 tw-text-xs tw-font-medium tw-uppercase tw-text-sf-slate-dark-1'

const dsBodyClasses =
  'tw-h-16 tw-px-4 tw-py-2.5 tw-bg-white tw-border-0 tw-border-b tw-border-solid tw-border-sf-slate-lighter-1'

const dsArrowClasses = 'tw-text-[10px] tw-text-sf-slate-light-2'

interface TableStyles {
  header: string
  body: string
  arrow: string
}

const variantStyles: Record<TableVariants, TableStyles> = {
  [tableVariants.DEFAULT]: { header: '', body: '', arrow: 'sf-c-primary' },
  [tableVariants.FLAT]: {
    header: flatClasses,
    body: flatClasses,
    arrow: 'sf-c-primary',
  },
  [tableVariants.DS]: {
    header: dsHeaderClasses,
    body: dsBodyClasses,
    arrow: dsArrowClasses,
  },
}

export const useTableStyles = (
  variant: MaybeRefOrGetter<TableVariants>
): {
  styles: ComputedRef<TableStyles>
} => ({
  styles: computed(() => variantStyles[toValue(variant)]),
})
